import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: false
})
export class ToastComponent implements OnInit {
  @Input() message: string | undefined;
  @Input() isSuccess: boolean | true;



  ngOnInit(): void {
    // On Init call
  }
}
